import React from 'react';
import WidgetWrapper from 'components/WidgetsList/WidgetWrapper/WidgetWrapper';
import './MasonaryWidget.scss';

const getImageLayout = (imagesCount, index) => {
    let layout = { rowSpan: 1, colSpan: 1 };

    const layouts = {
        1: [[6, 1]],
        2: [[3, 1], [3, 1]],
        3: [[3, 2], [3, 1], [3, 1]],
        4: [[2, 1], [4, 1], [4, 1], [2, 1]],
        5: [[2, 2], [2, 1], [2, 1], [2, 1], [2, 1]],
        6: [[3, 1], [2, 1], [1, 1], [1, 1], [3, 1], [2, 1]],
        7: [[2, 1], [1, 1], [1, 1], [2, 1], [2, 1], [3, 1], [1, 1]],
        8: [[2, 1], [1, 1], [1, 1], [2, 1], [2, 1], [1, 1], [2, 1], [1, 1]],
        9: [[2, 2], [2, 1], [2, 1], [4, 1], [2, 1], [1, 1], [1, 1], [1, 1], [1, 1]],
    };

    // Determine the correct layout pattern based on the number of images
    let layoutPattern = imagesCount <= 9 ? imagesCount : imagesCount % 9;

    // If layout pattern exists
    if (layouts[layoutPattern]) {
        // Calculate index for the layout pattern
        let layoutIndex = index % layouts[layoutPattern].length;

        [layout.colSpan, layout.rowSpan] = layouts[layoutPattern][layoutIndex];
    }

    return layout;
};

const truncate = (str, num) => {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};

const MasonaryWidget = ({ data }) => {
    return (
        <WidgetWrapper data={data}>
            
            
            <div className="tw-p-5 tw-bg-white tw-shadow-lg tw-rounded-md">
                <h2 className="tw-text-2xl tw-mb-3">{data.Title}</h2>
                <div className="tw-mb-5" dangerouslySetInnerHTML={{ __html: data.Content }} />
                <div className="md:tw-grid tw-grid-cols-6 tw-gap-4">
                    {data.MansoryImages.map((image, index) => {
                        const layout = getImageLayout(data.MansoryImages.length, index);
                        console.log(image);
                        return (
                            <a
                                href={image.Url || '#'}
                                key={index}
                                className={`
                                    ${layout.rowSpan === 1 ? 'grid-item-single' : 'grid-item-double'}
                                    tw-relative tw-border tw-border-gray-200 tw-rounded tw-overflow-hidden masonary-image tw-shadow-md 
                                    tw-row-span-${layout.rowSpan} tw-col-span-${layout.colSpan}
                                `}
                            >
                                <div className="tw-w-full tw-h-full tw-flex tw-flex-col tw-relative">
                                    <div className="tw-flex tw-justify-center tw-items-center tw-h-full ">
                                        <img src={image.Image.Url} alt={image.Image.Name} className="tw-object-cover tw-w-full tw-h-full masonary-image" />
                                    </div>
                                    {image.Title &&
                                        <div className="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bg-black tw-bg-opacity-50 tw-p-3">
                                            <h3 className="tw-text-lg tw-font-semibold tw-mb-2 tw-text-white">{image.Title}</h3>
                                        </div>
                                    }
                                    {image.Content &&
                                        <div className="tw-min-h-[70px] masonary-wrapepr-descr tw-hidden lg:tw-flex tw-items-center tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-bg-black tw-bg-opacity-50 tw-p-3">
                                            <div className="tw-text-white" dangerouslySetInnerHTML={{ __html: truncate(image.Content, 110) }} />
                                        </div>
                                    }
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
        </WidgetWrapper>
    );
};

 
export default MasonaryWidget;